import { HttpMethod, type IHttpClient } from '@/shared/contracts/http-client.contract';
import type { IUseCase } from '@/shared/contracts/use-case.contract';
import { atendimentoEndpoint, type AtendimentoCliente } from '../types';

type Input = { slug: string; search?: string; page?: number };

type Output = { data: AtendimentoCliente[]; meta: { page: number; has_more: boolean } };

export class ListAtendimentoClientesUseCase implements IUseCase<Input, Output> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute({ slug, search = '', page = 1 }: Input): Promise<Output> {
    const response = await this.client.sendRequest<Output, never>({
      endpoint: `${atendimentoEndpoint(slug)}/clientes`,
      method: HttpMethod.GET,
      params: { search: search.trim(), page },
    });

    return {
      data: response.data ?? [],
      meta: response.meta ?? { page, has_more: false },
    };
  }
}
